<template>
  <main>
    <div class="container-fluid">

      <ul class="nav nav-tabs  nav-tabs-custom   faq-tab-box" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="willProcessDisaster-tab" data-bs-toggle="pill" data-bs-target="#willProcessDisaster"
            type="button" role="tab" aria-controls="willProcessDisaster" aria-selected="true"> 查詢 </button>
        </li>

      </ul>

      <div class="tab-content p-3 shadow-sm" id="pills-tabContent" style="display: block;">
        <will-process-disaster></will-process-disaster>
      </div>
    </div>
  </main>
</template>

<script>
import willProcessDisaster from './willProcessDisaster.vue'




export default {
  components: { willProcessDisaster},
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {
 
  },
  mounted() {

  },
};
</script>

<style>
</style>
